import React from "react";
import getStateCode from "../../requests/hooks/getStateCode";
import CheckoutNote from "./CheckoutNote";

export default function Prop65({ zipcode }) {
  return getStateCode(zipcode) === "CA" ? (
    <CheckoutNote icon="exclamation-triangle" title="Prop 65 Warning">
      Some items contained in this catalog and distributed by Case Parts Company may contain chemicals known to the
      State of California to cause cancer or reproductive harm.
      <br />
      <a href="www.P65Warnings.ca.gov">www.P65Warnings.ca.gov</a>
    </CheckoutNote>
  ) : (
    ""
  );
}
